import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ParamRechazoCobro, HoraOption } from '../../models/param-rechazo-cobro.model';
import { ParamRechazoCobroService } from '../../services/param-rechazo-cobro.service';
import { UtilsService } from '../../../../shared/utils/utils.service';

@Component({
  selector: 'app-param-rechazo-cobro',
  templateUrl: './param-rechazo-cobro.component.html',
  styleUrls: ['./param-rechazo-cobro.component.css']
})
export class ParamRechazoCobroComponent implements OnInit {

  formulario: FormGroup;
  loading: boolean = false;
  loadingEjecucion: boolean = false;
  modoEdicion: boolean = false;
  horasDisponibles: HoraOption[] = [];
  ultimaEjecucion: string | null = null;

  constructor(
    private fb: FormBuilder,
    private paramService: ParamRechazoCobroService,
    private utils: UtilsService
  ) {
    this.inicializarHoras();
  }

  ngOnInit(): void {
    this.inicializarFormulario();
    this.cargarParametros();
  }

  inicializarFormulario(): void {
    this.formulario = this.fb.group({
      hora_ini: ['', Validators.required],
      hora_fin: ['', Validators.required],
      frecuencia: [0, [Validators.required, Validators.min(1)]],
      lapso_ejec: [0, [Validators.required, Validators.min(1)]],
      carga_extracto: [0, [Validators.required, Validators.min(1)]],
      lunes: [0],
      martes: [0],
      miercoles: [0],
      jueves: [0],
      viernes: [0],
      sabado: [0],
      domingo: [0]
    });
  }

  inicializarHoras(): void {
    for (let i = 0; i < 24; i++) {
      const hora = i.toString().padStart(2, '0') + ':00';
      this.horasDisponibles.push({
        value: hora,
        label: hora
      });
    }
  }

  cargarParametros(): void {
    this.loading = true;
    this.paramService.getParametros().subscribe(
      (response: any) => {
        if (response && response.respuesta) {
          this.modoEdicion = true;
          const datos = response.respuesta;
          
          // Guardar la última ejecución
          this.ultimaEjecucion = datos.ultimaEjecucion || null;
          
          // Convertir formato ISO datetime "1970-01-01T07:00:00" a "HH:mm" para que coincida con las opciones del select
          if (datos.hora_ini) {
            if (datos.hora_ini.includes('T')) {
              // Formato ISO: extraer la parte de la hora después de 'T'
              datos.hora_ini = datos.hora_ini.split('T')[1].substring(0, 5);
            } else if (datos.hora_ini.length > 5) {
              // Formato "HH:mm:ss": extraer solo HH:mm
              datos.hora_ini = datos.hora_ini.substring(0, 5);
            }
          }
          if (datos.hora_fin) {
            if (datos.hora_fin.includes('T')) {
              // Formato ISO: extraer la parte de la hora después de 'T'
              datos.hora_fin = datos.hora_fin.split('T')[1].substring(0, 5);
            } else if (datos.hora_fin.length > 5) {
              // Formato "HH:mm:ss": extraer solo HH:mm
              datos.hora_fin = datos.hora_fin.substring(0, 5);
            }
          }
          
          this.formulario.patchValue(datos);
        }
        this.loading = false;
      },
      (error) => {
        console.error('Error al cargar parámetros:', error);
        this.loading = false;
        this.modoEdicion = false;
      }
    );
  }

  ejecutarRechazo(): void {
    this.loadingEjecucion = true;
    
    this.paramService.ejecutarRechazo().subscribe(
      (response: any) => {
        this.loadingEjecucion = false;
        this.utils.mensajeOKVisto(response.mensaje || 'Proceso de rechazo ejecutado exitosamente.', false);
        this.cargarParametros();
      },
      (error) => {
        this.loadingEjecucion = false;
        console.error('Error al ejecutar rechazo:', error);
        this.utils.mensajeErrorVisto(error.error?.mensaje || 'Error al ejecutar el proceso de rechazo.');
      }
    );
  }
  
  guardar(): void {
    if (this.formulario.invalid) {
      this.utils.mensajeErrorVisto('Por favor complete todos los campos requeridos.');
      return;
    }

    // Validar que hora_fin sea mayor que hora_ini
    const horaIni = this.formulario.get('hora_ini')?.value;
    const horaFin = this.formulario.get('hora_fin')?.value;
    
    if (horaIni && horaFin && horaIni >= horaFin) {
      this.utils.mensajeErrorVisto('La hora fin debe ser mayor que la hora inicio.');
      return;
    }

    // Validar que al menos un día esté seleccionado
    /*const diasSeleccionados = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo']
      .some(dia => this.formulario.get(dia)?.value === 1);

    if (!diasSeleccionados) {
      this.utils.mensajeErrorVisto('Debe seleccionar al menos un día de la semana.');
      return;
    }*/

    this.loading = true;
    const datos: ParamRechazoCobro = this.formulario.value;

    // Agregar el campo ultimaEjecucion al objeto que se envía
    datos.ultimaEjecucion = this.ultimaEjecucion || '';

    // Convertir horas de "HH:mm" a formato DateTime "1970-01-01THH:mm:00"
    if (datos.hora_ini) {
      datos.hora_ini = `1970-01-01T${datos.hora_ini}:00`;
    }
    if (datos.hora_fin) {
      datos.hora_fin = `1970-01-01T${datos.hora_fin}:00`;
    }

    const operacion = this.paramService.guardarParametros(datos);

    operacion.subscribe(
      (response: any) => {
        this.loading = false;
        this.utils.mensajeOKVisto(response.mensaje || 'Parámetros guardados exitosamente.', false);
        this.modoEdicion = true;
        // Recargar parámetros para actualizar la última ejecución
        this.cargarParametros();
      },
      (error) => {
        this.loading = false;
        console.error('Error al guardar:', error);
        this.utils.mensajeErrorVisto(error.error?.mensaje || 'Error al guardar los parámetros.');
      }
    );
  }

  onCheckboxChange(dia: string, event: any): void {
    const valor = event.target.checked ? 1 : 0;
    this.formulario.get(dia)?.setValue(valor);
  }

  isChecked(dia: string): boolean {
    return this.formulario.get(dia)?.value === 1;
  }
}
